module.exports = __webpack_public_path__ + "static/media/emptyMap.c5e7e9c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/map/emptyMap.png
// module id = 1294
// module chunks = 0